import Dialog from './src/Dialog';

export default Dialog;
